export const vehicleConstant = {
    FETCH_VEHICLES_REQUEST: "FETCH_VEHICLES_REQUEST",
    FETCH_VEHICLES_SUCCESS: "FETCH_VEHICLES_SUCCESS",
    FETCH_VEHICLES_FAIL: "FETCH_VEHICLES_FAIL",
}